import { createSelector } from 'reselect';

export const selectMarketingMerchantsHome = state => state.marketingMerchantsHome;

// Merchants
export const selectMerchants =
  createSelector(selectMarketingMerchantsHome,
    marketingMerchantsHome => marketingMerchantsHome.marketingMerchantsHomeStores);
export const selectMerchantConfig = createSelector(selectMerchants, marketingMerchants => marketingMerchants.config);
export const selectMerchantIsLoading = createSelector(
  selectMerchants,
  marketingMerchants => marketingMerchants.isLoading,
);
export const selectMerchantIsLoaded = createSelector(
  selectMerchants,
  marketingMerchants => marketingMerchants.isLoaded,
);
export const selectMerchantData = createSelector(selectMerchants, marketingMerchants => marketingMerchants.merchants);

// Titles
export const selectTitles =
  createSelector(selectMarketingMerchantsHome, marketingMerchantsHome =>
    marketingMerchantsHome.marketingMerchantsHomeTitles);
export const selectTitlesConfig = createSelector(selectTitles, marketingTitles => marketingTitles.config);
export const selectTitleData = createSelector(selectTitles, marketingTitles => marketingTitles.titles);
export const selectTitlesIsLoading = createSelector(selectTitles, marketingTitles => marketingTitles.isLoading);
export const selectTitlesIsLoaded = createSelector(selectTitles, marketingTitles => marketingTitles.isLoaded);
